/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

    require('./bootstrap');

    // Vue 3 imports
    import { createApp } from 'vue';
    import { createRouter, createWebHashHistory } from 'vue-router';
    import { createStore } from 'vuex';

    // Import your Vuex store configuration
    import { storeConfig } from './store';

    // Import plugins
    import VueSweetalert2 from 'vue-sweetalert2';
    import 'sweetalert2/dist/sweetalert2.min.css';

    // --- PivotTable --- (Check if Vue 3 compatible version exists)
    // import VuePivottable from 'vue-pivottable'
    // import 'vue-pivottable/dist/vue-pivottable.css'

    // --- Leaflet ---
    // import L from 'leaflet'
    import 'leaflet/dist/leaflet.css'

    // --- TheMask --- (Check for Vue 3 compatibility)
    // import VueTheMask from 'vue-the-mask';

    // --- ToggleButton --- (Check for Vue 3 compatibility)
    // import ToggleButton from 'vue-js-toggle-button'

    import axios from 'axios';
    import NotFoundComponent from './components/NotFoundComponent.vue';

    // Import Multiselect for Vue 3
    import Multiselect from '@vueform/multiselect';
    import '@vueform/multiselect/themes/default.css';

    // Import components
    import RmxAtenderDestinos  from './components/ceroPapel/cmp/rmxAtenderDestinos.vue';
    import RmxAtenderCopias    from './components/ceroPapel/cmp/rmxAtenderCopias.vue';
    // Árbol recursivo de nodos — registrado globalmente porque se usa en
    // RegistroWizard, BandejaUnificada y ArbolOrganigrama (incluido dentro de sí mismo)
    import NodoArbolItem       from './components/ceroPapel/cmp/NodoArbolItem.vue';
    // Import TinyMCE Vue component
    import  Editor  from '@tinymce/tinymce-vue';
    // toast-notifications
    import ToastPluging from 'vue-toast-notification';
    import 'vue-toast-notification/dist/theme-bootstrap.css';
    // import custom gestora-axios-plugin
    import {axiosGtalento} from './plugins/axios';

    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';

    import gTalentoUppercase from './directives/gtalento-uppercase.directive';
    import gTalentoLowercase from './directives/gtalento-lowercase.directive';

    // PrimeVue imports
    import PrimeVue from 'primevue/config';
    import Aura from '@primevue/themes/aura';
    import Stepper from 'primevue/stepper';
    import StepList from 'primevue/steplist';
    import Step from 'primevue/step';
    import StepPanels from 'primevue/steppanels';
    import StepPanel from 'primevue/steppanel';
    import Button from 'primevue/button';
    import TreeSelect from 'primevue/treeselect';

    // PrimeIcons
    import 'primeicons/primeicons.css';

    // Define routes
    let routes = [
        { path: '/dashboard', props: true, component: () => import('./components/Dashboard.vue') },
        { path: '/users', component: () => import('./components/parametros/Users.vue') },
        { path: '/usersNodos', component: () => import('./components/parametros/UsersNodos.vue') },
        { path: '/cambioAgenciaUsers', component: () => import('./components/parametros/cambioAgenciaUsers.vue') },
        { path: '/nodosProcesos', component: () => import('./components/parametros/NodosProcesos.vue') },
        { path: '/profile', component: () => import('./components/Profile.vue') },
        { path: '/', component: () => import('./components/Profile.vue') },

        { path: '/procesos', component: () => import('./components/diseno/Procesos.vue') },
        { path: '/modeladoProceso/:prc_id', props: true, component: () => import('./components/diseno/modeladoProceso.vue') },
        { path: '/actividades', component: () => import('./components/diseno/Actividades.vue') },
        { path: '/formularios', component: () => import('./components/diseno/Formularios.vue') },
        { path: '/modeladoFormularios', component: () => import('./components/diseno/modeladoFormulario.vue') },
        { path: '/f3', component: () => import('./components/reportes/F3.vue') },
        { path: '/disenoProceso', component: () => import('./components/diseno/F4.vue') },
        { path: '/impresiones', component: () => import('./components/diseno/Impresiones.vue') },

        { path: '/nodos', component: () => import('./components/parametros/Nodos.vue') },
        { path: '/catalogos', component: () => import('./components/parametros/Catalogos.vue') },
        { path: '/tactividades', component: () => import('./components/parametros/TActividades.vue') },
        { path: '/tformularios', component: () => import('./components/parametros/TFormularios.vue') },
        { path: '/estadosAvance', component: () => import('./components/parametros/estadosAvance.vue') },
        { path: '/actuaciones', component: () => import('./components/parametros/Actuaciones.vue') },
        { path: '/formacioncampo', component: () => import('./components/parametros/FormacionCampo.vue') },
        { path: '/ajustesSolicitudes', component: () => import('./components/soporte/AjustesSolicitudes.vue') },

        { path: '/tipows', component: () => import('./components/ws/TipoWs.vue') },
        { path: '/ws', component: () => import('./components/ws/Ws.vue') },

        { path: '/crearCaso', component: () => import('./components/CrearCaso.vue') },
        { path: '/misCasos', component: () => import('./components/MisCasos.vue') },
        { path: '/atenderCaso/:url_encode_cas_id', props: true, component: () => import('./components/AtenderCaso.vue') },
        // { path: '/atenderCasoRender/:cas_id', props: true, component: () => import('./components/AtenderCasoRender.vue') },
        { path: '/buscarCasos', component: () => import('./components/BuscarCasos.vue') },
        { path: '/oficinas', component: () => import('./componentsErp/oficinas/Oficinas.vue') }, // oficinas*
        { path: '/cierreTramites', component: () => import('./components/CierreTramites.vue') },
        { path: '/CambiarContrasena', component: () => import('./components/CambiarContrasena.vue') },

      

        { path: '/archivos', component: () => import('./components/archivos/parametros/Archivos.vue') },
        { path: '/tiposArchivo', component: () => import('./components/archivos/parametros/TiposArchivo.vue') },
        { path: '/tiposDoc', component: () => import('./components/archivos/parametros/TiposDoc.vue') },
        { path: '/subtiposDoc', component: () => import('./components/archivos/parametros/SubtiposDoc.vue') },

        { path: '/nodosTrabajos', component: () => import('./components/reportes/NodosTrabajos.vue') },
        { path: '/reporteProceso', component: () => import('./components/reportes/ReporteProcesos.vue') },
        { path: '/reporteJubilacion', component: () => import('./components/reportes/ReporteProcesosJubilacion.vue') },
        { path: '/reporteFinanzas', component: () => import('./components/reportes/ReporteProcesosFinanzas.vue') },

        { path: '/registroPasaporte', component: () => import('./components/registroPasaporte.vue') },
        { path: '/buscarDocumentos', component: () => import('./components/buscarDocumentos.vue') },

        { path: '/notificacionFechas', component: () => import('./components/GetNotificacionFechas.vue') },
        { path: '/notificacionComplementarios', component: () => import('./components/NotificacionComplementarios.vue') },
        { path: '/notificaciones', component: () => import('./components/Notificaciones.vue') },
        { path: '/administrarPendientes', component: () => import('./components/AdministrarPendientes.vue') },

        { path: '/correo', component: () => import('./components/correo/email.vue') },
        { path: '/sms', component: () => import('./components/correo/celular.vue') },

        { path: '/servicio-controller', component: () => import('./components/ACGComponent.vue') },
        { path: '/externo-firma', component: () => import('./components/externo/ExternoFirma.vue') },
        { path: '/externo-firmaC', component: () => import('./components/externo/ExternoFirmaC.vue') },
        { path: '/desistido', component: () => import('./components/externo/DesistidoComponent.vue') },
        { path: '/metricas-gtalento', component: () => import('./components/DashboardV2.vue') },
        { path: '/unauthorized', component: () => import('./components/Unauthorized.vue') },
        { name: 'roles', path: '/roles', component: () => import('./components/parametros/Roles.vue') },
        { name: "rol-usuarios", path: '/rol-usuarios/:payload', component: () => import('./components/parametros/UsuariosRoles.vue'), props: true },
        { name: "rol-accesos", path: '/rol-accesos/:payload', component: () => import('./components/parametros/AccesosRolComponent.vue'), props: true },
        { name: "menu-option", path: '/menu-option', component: () => import('./components/parametros/MenuOption.vue'), props: true },
        { name: "menu-group", path: '/menu-group', component: () => import('./components/parametros/MenuGroup.vue'), props: true },

        // Catch-all route (404) - Vue 3 syntax
        { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundComponent },

        // RUTAS PARA EL MÓDULOS ERP //
        { path: '/persona_erp', component: () => import('./componentsErp/persona/PersonaGrid.vue') },
        { path: '/usuario-erp', component: () => import('./componentsErp/usuarios/UsuarioERP.vue') },
        { path: '/funcionario-erp', component: () => import('./componentsErp/funcionario/FuncionarioERP.vue') },
        { path: '/support2025', component: () => import('./componentsErp/usuarios/Support2025.vue') },
        // { path: '/support2025', component: () => import('./componentsErp/persona/test-components/Prime-component.vue') },
        // { path: '/support2025', component: () => import('./componentsErp/angular-mimic-rol/RolGrid.vue') },

        //RUTAS PARA ORGANIGRAMA
        { path: '/estructuraOrganizacional', component: () => import('./componentsErp/organigrama/EstructuraOrganizacional.vue') },
        { path: '/cargoJerarquia', component: () => import('./componentsErp/organigrama/cargoJerarquia.vue') },
         //RUTAS PARA FILE CONTRATACIONES
         { path: '/filePersonal', component: () => import('./componentsErp/filePersonal/filePersonal.vue') },
         { path: '/fileGestion', component: () => import('./componentsErp/filePersonal/gestion.vue') },
         { path: '/documentos', component: () => import('./componentsErp/filePersonal/documento.vue') },
         { path: '/tipoContrato', component: () => import('./componentsErp/filePersonal/tipoContrato.vue') },
         { path: '/tipoContratoFase', component: () => import('./componentsErp/filePersonal/tipoContratoFase.vue') },
         { path: '/documentoscontratofase', component: () => import('./componentsErp/filePersonal/documentoscontratofase.vue') },

        // RUTAS PARA EL MÓDULOS HOJA DE VIDA //
        { path: '/actualizarDatosPersonales', component: () => import('./componentsErp/fichaPersonal/ActualizarDatosPersonales.vue') },
         { path: '/fichaPersonal', component: () => import('./componentsErp/fichaPersonal/fichaPersonal.vue') },
         { path: '/formacionAcademica', component: () => import('./componentsErp/fichaPersonal/formacionView.vue') },
        { path: '/cursosRealizados', component: () => import('./componentsErp/fichaPersonal/cursosRealizados.vue') },
        { path: '/experienciaLaboral', component: () => import('./componentsErp/fichaPersonal/expLaboral.vue') },
        { path: '/conocimientoIdiomas', component: () => import('./componentsErp/fichaPersonal/conocIdiomas.vue') },

        //RUTAS PARA UNIDAD VERSION
        { path: '/estructuraUoVersion', component: () => import('./componentsErp/estructuraUoVersion/EstructuraUoVersion.vue') },

        //RUTA PARA EL MODULO DE ROLES
        //{ path: '/rolAcceso', component: () => import('./componentsErp/rol/RolAcceso.vue') },

        // Ldap componentes
        { path: '/usuariosLdap', component: () => import('./componentsErp/ldap/usuarios/UsuarioLDAP.vue') },
        { path: '/listarOus', component: () => import('./componentsErp/ldap/OU/ListarOus.vue') },
        { path: '/estructura-ou-arbol', component: () => import('./componentsErp/ldap/OU/EstructuraOuArbol.vue') },
        { path: '/estructura-ou-arbol-usuarios', component: () => import('./componentsErp/ldap/OU/EstructuraOuArbolUsuarios.vue') },

        // funcionario V2
        { path: '/listadofuncionarios', component: () => import('./componentsErp/funcionario/FuncERPV2.vue') },        
        //registrar 
       
          // ── Módulo Correspondencia v2 ─────────────────────────────────────────
        { path: '/registroWizard',           component: () => import('./components/ceroPapel/RegistroWizard.vue') },
        { path: '/bandejaUnificada',         component: () => import('./components/ceroPapel/BandejaUnificada.vue') },
        { path: '/arbolOrganigrama',         component: () => import('./components/ceroPapel/ArbolOrganigrama.vue') },
        { path: '/dashboardCorrespondencia', component: () => import('./components/DashboardStats.vue') },

        { path: '/buscarCorrespondencia', component: () => import('./components/ceroPapel/BuscarCorrespondencia.vue') },
        { path: '/bandejaCorrespondencia', component: () => import('./components/ceroPapel/BandejaCorrespondencia.vue') },
        { path: '/crearCorrespondencia',    component: () => import('./components/ceroPapel/CrearCorrespondencia.vue') },
        { path: '/reporteCorrespondencia', component: () => import('./components/ceroPapel/ReporteCorrespondencia.vue') },
        { path: '/reporteGeneral',         component: () => import('./components/ceroPapel/ReporteGeneral.vue') },
        { path: '/reporteUsuario',         component: () => import('./components/ceroPapel/ReporteUsuario.vue') },
        { path: '/reporteFechas',          component: () => import('./components/ceroPapel/ReporteFechas.vue') },
        { path: '/corteVentanilla',        component: () => import('./components/ceroPapel/CorteVentanilla.vue') },
        { path: '/reporteBandeja',         component: () => import('./components/ceroPapel/ReporteBandeja.vue') },
        { path: '/atenderCorrespondencia/:crr_id', props: true, component: () => import('./components/ceroPapel/AtenderCorrespondencia.vue') },
        { path: '/atenderActuaciones/:crr_id', props: true, component: () => import('./components/ceroPapel/AtenderActuaciones.vue') },
        { path: '/atenderContenido/:crr_id', props: true, component: () => import('./components/ceroPapel/AtenderContenido.vue') },

        // ── Módulo RRHH ───────────────────────────────────────────────────────
        { path: '/rrhh/dashboard',               component: () => import('./components/rrhh/RrhhDashboard.vue') },//*
        // Empleados
        { path: '/rrhh/empleados',               component: () => import('./components/rrhh/RrhhEmpleados.vue') },//*
        { path: '/rrhh/empleados/:id', props:true,component: () => import('./components/rrhh/RrhhEmpleadoFicha.vue') },
        { path: '/rrhh/contratos',               component: () => import('./components/rrhh/RrhhContratos.vue') },
        { path: '/rrhh/file',                    component: () => import('./components/rrhh/RrhhFileExpedientes.vue') },
        // Asistencia
        { path: '/rrhh/asistencia',              component: () => import('./components/rrhh/RrhhAsistencia.vue') },
        // Planilla
        { path: '/rrhh/planilla',                component: () => import('./components/rrhh/RrhhPlanilla.vue') },
        // Solicitudes
        { path: '/rrhh/solicitudes',             component: () => import('./components/rrhh/RrhhSolicitudes.vue') },
        // Procesos de baja
        { path: '/rrhh/bajas',                   component: () => import('./components/rrhh/RrhhBajas.vue') },//*
        { path: '/rrhh/notificaciones',          component: () => import('./components/rrhh/RrhhNotificaciones.vue') },
        // Reportes
        { path: '/rrhh/reportes/multas',         component: () => import('./components/rrhh/RrhhReporteMultas.vue') },//** 
        { path: '/rrhh/reportes/asistencia',     component: () => import('./components/rrhh/RrhhReporteAsistencia.vue') },
        { path: '/rrhh/reportes/antiguedad',     component: () => import('./components/rrhh/RrhhReporteAntiguedad.vue') },
        // ── /RRHH ─────────────────────────────────────────────────────────────

    ];

    // Async function to initialize the app
    async function initializeApp() {
        // Create Vuex store
        const store = createStore(storeConfig);

        //###################### 2025-01-28 manage rol begin
        const windowLaravel = window.Laravel;
        const userId = windowLaravel && windowLaravel.usr_id ? windowLaravel.usr_id : -1;
        const tokenLaravel = windowLaravel && windowLaravel.csrf_token ? windowLaravel.csrf_token : null;

        try {
            // Fetch user roles
            const responseRoles = await axios.get("api/getRolesOfUser/" + userId);
            const dataDB = responseRoles.data.data[0];
            const accessDB = dataDB.accesos;
            const rolesDB = dataDB.roles;

            // Update store with user role and token
            store.dispatch('updateUserRole', rolesDB);
            store.dispatch('updateToken', tokenLaravel);

            // Configure route meta information
            routes.forEach(route => {
                const metaInfo = {
                    requiresAuth: true,
                    requiredRole: []
                };
                const uniqueId = crypto.randomUUID();
                const index = accessDB.findIndex(item => item.url.trim() === route.path.trim());

                if (route.path.trim() === "/unauthorized" || route.path.trim() === "/profile" || route.path.trim() === "/:pathMatch(.*)*") {
                    metaInfo.requiresAuth = false;
                } else if (index !== -1) {
                    metaInfo.requiredRole.push(rolesDB);
                } else {
                    metaInfo.requiredRole.push(uniqueId);
                }
                route.meta = metaInfo;
            });
        } catch (error) {
            console.error('Error fetching user roles:', error);
        }

        // Create router
        const router = createRouter({
            history: createWebHashHistory('/home'),
            routes
        });

        // Navigation Guard
        router.beforeEach((to, from, next) => {
            // Redirect from login-view to profile-view
            if (from.fullPath ==='/' && to.fullPath === '/') {
                next({ path: '/profile' });
                return;
            }

            // Check if route requires authentication
            if (to.matched.some(record => record.meta.requiresAuth)) {
                // Check if user is logged in
                if (!store.getters.isAuthenticated) {
                    next({
                        path: '/',
                        query: { redirect: to.fullPath }
                    });
                    return;
                }

                // Check if route has required role
                if (to.meta.requiredRole) {
                    const userRole = store.getters.userRole;
                    const requiredRole = to.meta.requiredRole;

                    // Handle both single role and array of roles
                    const hasPermission = Array.isArray(requiredRole) ?
                        requiredRole.includes(userRole) :
                        requiredRole === userRole;

                    if (!hasPermission) {
                        next({ path: '/unauthorized' });
                        return;
                    }
                }
            }

            next();
        });

        // Create Vue 3 app
        const app = createApp({
            methods: {
                closeModalAndRedirect(route) {
                    // jQuery is still available if needed
                    $('.modal').modal('hide');

                    setTimeout(() => {
                        this.$router.push(route);
                    }, 500);
                }
            }
        });

        // Install directives
        app.directive('gTalentoUppercase', gTalentoUppercase);
        app.directive('gTalentoLowercase', gTalentoLowercase);

        // Install plugins
        app.use(router);
        app.use(store);
        app.use(VueSweetalert2);
        app.use(PrimeVue, {
            theme: {
                preset: Aura
            }
        });

        // Register global components
        app.component('VueDatePicker', VueDatePicker);
        app.component('multiselect', Multiselect);
        // Árbol recursivo de nodos — global porque se auto-referencia y se usa en varios módulos
        app.component('nodo-arbol-item', NodoArbolItem);
        app.component('rmx-atender-destinos', RmxAtenderDestinos);
        app.component('rmx-atender-copias', RmxAtenderCopias);
        app.component('Editor', Editor);
        // Primevue components
        app.component('Stepper', Stepper);
        app.component('StepList', StepList);
        app.component('Step', Step);
        app.component('StepPanels', StepPanels);
        app.component('StepPanel', StepPanel);
        app.component('Button', Button);
        app.component('TreeSelect', TreeSelect);

        // Global properties (equivalent to Vue.prototype in Vue 2)
        app.config.globalProperties.window = window;

        // Global errorCaptured mixin
        app.mixin({
        data() {
            return { __hasError: false }
        },
        errorCaptured(err, instance, info) {
            //2025-06-25 vue3 is more strict,issue: vue3 if some component has issue this may affect a siblim components or parent components on the tree-components.
            // solution1: F5 over the component that has no issue.
            // solution2: isolate those render errors so that one broken component won’t drag down its siblings, and you won’t need to hit F5 every time(implemented)
            console.error('[Global Catch]', info, err)
            this.__hasError = true
            // Returning false prevents the error from unmounting parent chain
            return false
        }
        });

        // Register plugins
        app.use(ToastPluging);
        // Register custom axios plugin
        //2025-07-22
        app.config.globalProperties.$axiosGtalento = axiosGtalento;

        // Mount the app
        app.mount('#app');
    }

// Initialize the app
initializeApp().catch(error => {
    console.error('Failed to initialize app:', error);
});

//###################### 2025-01-28 manage rol end
